// set by geom activeFeature
export const setActiveFeature = (activeFeature) => ({
  type: "ACTIVE_FEATURE:SET",
  payload: activeFeature ? activeFeature.properties["Functional"] : null,
});
// set by name
export const setActiveFeatureByName = (activeFeatureName) => ({
  type: "ACTIVE_FEATURE:SET",
  payload: activeFeatureName,
});
export const setClickedFeature = (clickedFeature) => ({
  type: "CLICKED_FEATURE:SET",
  payload: clickedFeature,
});
export const setHoveredFeature = (hoveredFeature) => ({
  type: "HOVERED_FEATURE:SET",
  payload: hoveredFeature,
});
export const setSearchBarVisible = (isVisible) => ({
  type: "SEARCH_BAR_VISIBLE:SET",
  payload: isVisible,
});
export const setSearchedLocation = (latLng) => ({
  type: "SEARCHED_LOCATION:SET",
  payload: latLng,
});
export const setActiveProject = (x) => ({
  type: "ACTIVE_PROJECT:SET",
  payload: x,
});
export const setActiveFilter = (hub) => ({
  type: "ACTIVE_FILTER:SET",
  payload: hub,
});
export const setAllFilters = () => {
  return {
    type: "ACTIVE_FILTER:SET_ALL",
  };
};
export const setBasemap = (imagery) => ({
  type: "MAP:SET_BASEMAP",
  payload: imagery,
});
export const setActivePage = (page) => ({
  type: "ACTIVE_PAGE:SET",
  payload: page,
});
export const setMapType = (mapType) => ({
  type: "MAP_TYPE:SET",
  payload: mapType,
});
export const setZoomToNsw = (x) => ({
  type: "ZOOM_TO_NSW",
  payload: x,
});
export const setSidebarIsOpen = (isOpen) => ({
  type: "SIDEBAR:OPEN",
  payload: isOpen,
});
export const scrollToTopOfSidebar = (isOpen) => ({
  type: "SIDEBAR:SCROLLUP",
  payload: Date.now(),
});



// WEBPACK FOOTER //
// ./src/actions/ui.js